import notification from './feedback/notification';

const createNotification = (type, message, description, btn, key) => {
  notification[type]({
    message,
    description,
    btn,
    key
  });
};
export default createNotification;
